// extracted by mini-css-extract-plugin
export default {"questionMarkContainer":"QuestionMarkAnimation_questionMarkContainer__tzO1T","questionMarkAnimation":"QuestionMarkAnimation_questionMarkAnimation__BtQC3"};